import React from "react";
import { FormattedMessage, type MessageDescriptor } from "react-intl";
import type { WrappedFieldProps } from "redux-form";

export function ClinicInput({
  input,
  meta,
  message,
  ...props
}: WrappedFieldProps & { message?: MessageDescriptor["id"]; type: "text" | "textarea" }) {
  const error = meta.touched && meta.error;

  if (props.type == "textarea") {
    return (
      <div>
        <textarea {...input} {...props} />
      </div>
    );
  }

  return (
    <div className={error && message ? "has-error" : ""}>
      <input {...input} {...props} />
      {error ? <span>{message && <FormattedMessage id={message} />}</span> : null}
    </div>
  );
}
